/**
 * Panel
 *
 */
import React from 'react'
import { connect } from 'react-redux'

const Panel = ({ theme, styles, style, children, className, onClick, hoverable }) => (
  <div
    style={{ ...theme.styles.panel, ...styles, ...style }}
    className={[`app-panel ${className || ''}`].concat(hoverable ? ['hoverable'] : []).join(' ').trim()}
    onClick={onClick}
    children={children}
  />
)

const connectedPanel = connect(
  state => ({ theme: state.theme.values })
)(Panel)

export default connectedPanel
